import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import * as S from './style';

export interface Props {
    children: React.ReactNode | string;
    height?: number;
    backGroundColor?: string;
    boarderColor?: string;
    color?: string;
    fontStyle?: string;
    radius?: number;
    href?: string;
    value?: string | number;
    disabled?: boolean;
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function Btn({ children, href, ...props }: Props): React.ReactElement {
    const history = useHistory();

    const onClickHrefCallback = useCallback(
        (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            if (href) history.push(href);
        },
        [history, href]
    );

    if (href) {
        return (
            <S.Button {...props} onClick={onClickHrefCallback}>
                {children}
            </S.Button>
        );
    } else {
        return <S.Button {...props}>{children}</S.Button>;
    }
}
export default Btn;
